import { eEnv } from '@/constants';

export const RUNNING_ENVIRONMENT = (
  process.env.VITE_NODE_ENV ? process.env.VITE_NODE_ENV : eEnv.DEV
) as eEnv;

/**
 * Feature flag gating the AI Wizard "Tenant Context" admin tab.
 * Hidden by default; set VITE_FEATURE_TENANT_CONTEXT_ENABLED=true per environment to expose it.
 */
export const IS_TENANT_CONTEXT_TAB_ENABLED =
  process.env.VITE_FEATURE_TENANT_CONTEXT_ENABLED === 'true';
